export const ApiPaths = {
    GET_CONFIGURATION: "/api/public/configuration",
    STUDENT_WELCOME_PAGE: "/api/account/student/welcome",
    FORGOT_PASSWORD: "/api/account/password/forgot",
    FORGOT_USERNAME: "/api/account/username/forgot",
    PASSWORD_RESET: "/api/account/password/reset",
    PASSWORD_RESET_AUTH: "/api/account/password/reset/auth",
    REGISTER: "/api/account",
    UPDATE_ACCOUNT_LANGUAGE: "/api/account/language",
    SEND_COMPLETE_REGISTRATION_REQUEST_EMAIL: "/api/account/sendCompleteRegistrationRequestEmail",
    UPDATE_PASSWORD: "/api/accounts/__AID__/password",
    HEARTBEAT: "/api/public/configuration/heartbeat"
};